<div fxLayout="column" fxLayoutGap="20px" class="layout-padd" fxLayoutAlign="center center"
  [ngStyle]="{'max-height.px': innerHeight}" fxFlexFill>

 
  <div fxLayout="row" fxLayoutAlign="center center" class="layout-padd full-w">
    <h3 >{{'bookBarcodeComponent.booking'|translate}}  {{bookingRef.reference}}</h3>
    </div>
 
  

    <div fxLayoutAlign="center center" >
      <img src="{{bookingRef.reference_base64}}">
    </div>


  <button mat-stroked-button class="full-w dark-ico" (click)="closeDial()" angulartics2On="click"
    angularticsAction="closeMaxWeightDial" angularticsCategory="order">
    <span class="mat-title">{{"dialogs.go-back" | translate}}</span>
  </button>

</div>